import type { PulseProviderInput } from '@pulse/react';

const PULSE_ENVIRONMENTS = ['prod', 'dev', 'stage', 'local'] as const;
type PulseEnvironment = (typeof PULSE_ENVIRONMENTS)[number];

const getPulseEnvironment = (): PulseEnvironment | undefined => PULSE_ENVIRONMENTS.find(value => value === process.env.NEXT_PUBLIC_PULSE_ENV);

export const remoteSettings: PulseProviderInput = {
  app: 'com.picsart.apps.genai',
  tracker: { environment: getPulseEnvironment() },
};
